import { useDataSubmit, useDataValue } from 'Simple/Data.js'
export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let connection_id = useDataValue({
    context: 'sync',
    viewPath: props.viewPath,
    path: 'connection_id',
  })
  return function onClick() {
    submit({
      type: 'sync',
      connection_id,
    })
  }
}
